import { LoadableAfterPaint } from '@confluence/loadable';

export const AdminAnnouncementBanner = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AdminAnnouncementBanner" */ '../src/AdminAnnouncementBanner.tsx'
			)
		).AdminAnnouncementBanner,
});
